import React from 'react';
import { CircularProgress } from '@mui/material';

const PdfTopUsers = ({ loading, stats }) => {
  const rows = stats?.topUsers || [];

  return (
    <div className="pdfTableGrid pdfTopUsersTableGrid">
      <div className="pdfTableGridHeader">
        <div className="pdfTableGridCell">#</div>
        <div className="pdfTableGridCell">Name</div>
        <div className="pdfTableGridCell">Email</div>
        <div className="pdfTableGridCell">Total</div>
        <div className="pdfTableGridCell">Success</div>
        <div className="pdfTableGridCell">Failed</div>
      </div>
      {loading ? (
        <div style={{ padding: '1rem' }}>
          <CircularProgress size={24} />
        </div>
      ) : (
        rows.map((row, index) => (
          <div className="pdfTableGridRow" key={row.userId || index}>
            <div className="pdfTableGridCell">{index + 1}</div>
            <div className="pdfTableGridCell">{row.name || '-'}</div>
            <div className="pdfTableGridCell">{row.email || '-'}</div>
            <div className="pdfTableGridCell">{row.total}</div>
            <div className="pdfTableGridCell">{row.success}</div>
            <div className="pdfTableGridCell">{row.failed}</div>
          </div>
        ))
      )}
    </div>
  );
};

export default PdfTopUsers;
